module.exports = __webpack_public_path__ + "static/media/9-Clubs.0ef2ed0b.svg";